import { type FC } from "react";
import { Input } from "@/components/essentials/input";
import { useFormContext } from "react-hook-form";
import { FormControl, FormLabel } from "@/components/essentials/form-control";
import { recoveryCodeFormLabelTestId, recoveryCodeFormInputTestId } from "./const";
import { type RecoveryCodeFormValue } from "./type";

export const RecoveryCodeForm: FC = () => {
  const {
    register,
    formState: { errors, dirtyFields },
  } = useFormContext<RecoveryCodeFormValue>();
  return (
    <FormControl
      id="recoveryCode"
      isRequired
      isDirty={dirtyFields.recoveryCode !== undefined}
      isInvalid={errors.recoveryCode !== undefined}
    >
      <FormLabel data-testid={recoveryCodeFormLabelTestId}>リカバリーコード</FormLabel>
      <Input
        data-testid={recoveryCodeFormInputTestId}
        type="text"
        inputMode="text"
        placeholder="リカバリーコードを入力してください"
        {...register("recoveryCode", {
          required: true,
          maxLength: 8,
          minLength: 8,
        })}
      />
    </FormControl>
  );
};
